// Where the app lands when the onboarding wizard finishes. An agent always lands
// on the Dashboard, whether they start the welcome tour (which targets the
// Dashboard) or skip it. A transaction coordinator lands on the Transactions tab,
// where the TC overlay opens.
export function postOnboardingLanding({ isTcMode }) {
    if (isTcMode) return { kind: 'tab', tab: 'transactions' };
    return { kind: 'route', path: '/' };
}

const TC_ROLE = 'transactionCoordinator';

// The role and TC mode to apply when the wizard finishes (C-CR-01). The wizard
// has no Role step, so it sends no role, and finishing it (including "Replay
// setup" from the Help drawer) must keep what the user already has. A stored
// role wins; only an account with no stored role becomes a realtor. TC mode is
// whatever the user last set, and is only written when a caller explicitly
// passes a role (`writesTcMode`), so a replay never rewrites isTcModeEnabled.
export function resolveOnboardingRole({ payloadRole, userSettings } = {}) {
    if (payloadRole) {
        const role = payloadRole === TC_ROLE ? TC_ROLE : 'realtor';
        return { role, isTcMode: role === TC_ROLE, writesTcMode: true };
    }
    const role = userSettings?.role === TC_ROLE ? TC_ROLE : 'realtor';
    return { role, isTcMode: Boolean(userSettings?.isTcModeEnabled), writesTcMode: false };
}
